
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./SearchResults.css";

export default function SearchResults() {
  const { query } = useParams();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const slugify = (text) =>
    text?.toString().toLowerCase().trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-ء-ي]/g, "")
      .replace(/\-\-+/g, "-");

  useEffect(() => {
    axios
      .get(`https://ppmn.net/dash/api/search/${encodeURIComponent(query)}`)
      .then((res) => {
        setResults(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("حدث خطأ في جلب نتائج البحث:", err);
        setLoading(false);
      });
  }, [query]);

  if (loading) return <div className="text-center my-5">جاري التحميل...</div>;

  return (
    <div className="container my-5">
      <h3 className="mb-4">
        نتائج البحث عن: <span className="text-primary">{query}</span>
      </h3>

      {results.length === 0 ? (
        <p>لم يتم العثور على نتائج.</p>
      ) : (
        <div className="d-flex flex-wrap justify-content-start gap-4">
          {results.map((article, index) => {
            const category = article.category_key || "multi-news";
            const id = article.article_id || article.report_id;
            const title = article.article_title || article.report_title;

            return (
              <div
                key={index}
                className="search-card"
                onClick={() => navigate(`/News/${category}/${id}/${slugify(title)}`)}
                style={{ cursor: "pointer", width: "300px" }}
              >
                <div className="card h-100 shadow-sm">
                  <img
                    src={article.article_title_image || article.report_image}
                    className="card-img-top"
                    alt={title}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title" style={{ fontSize: "18px" }}>
                      {title.length > 80 ? title.slice(0, 80) + "..." : title}
                    </h5>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
